import { axiosInstance } from "@/config/axios";
import { objectToSnake } from "ts-case-convert";

interface Params {
  uuid: string;
  body: {
    role: "operator" | "customer_new" | "customer_old";
    newCustomerReason?: "mrd" | "stop" | "other" | "second_ean";
    note?: string;
  };
}

export const stornoRequest = async ({ uuid, body }: Params) => {
  return axiosInstance.post(`/request/${uuid}/storno`, objectToSnake(body));
};
